import axios from 'axios'
import { defineStore } from 'pinia'

const errorMessage = error => error.response?.data?.message ?? 'Unable to load your companies. Please try again.'

export const useUserCompanyStore = defineStore('holidaysPublicUserCompanies', {
  state: () => ({
    companies: [],
    company: null,
    companyError: null,
    isLoadingCompany: false,
    companyRequestId: 0,
    search: '',
    pagination: {
      currentPage: 1,
      lastPage: 1,
      total: 0,
    },
    isLoading: false,
    error: null,
  }),

  actions: {
    async fetchCompany(companyUuid) {
      const requestId = ++this.companyRequestId
      this.company = null
      this.companyError = null
      this.isLoadingCompany = true

      try {
        const { data } = await axios.get(`/api/v1/holidays-public/my-companies/${companyUuid}`)
        if (requestId === this.companyRequestId) {
          this.company = data.data
        }
      } catch (error) {
        if (requestId === this.companyRequestId) {
          this.companyError = errorMessage(error)
        }
      } finally {
        if (requestId === this.companyRequestId) {
          this.isLoadingCompany = false
        }
      }
    },
    async fetchCompanies(page = 1) {
      this.isLoading = true
      this.error = null

      try {
        const { data } = await axios.get('/api/v1/holidays-public/my-companies', {
          params: {
            page,
            search: this.search || undefined,
          },
        })
        this.companies = data.data
        this.pagination = {
          currentPage: data.meta.current_page,
          lastPage: data.meta.last_page,
          total: data.meta.total,
        }
      } catch (error) {
        this.companies = []
        this.error = errorMessage(error)
        throw error
      } finally {
        this.isLoading = false
      }
    },
  },
})
